module.exports = __webpack_public_path__ + "img/kway.f23cc033.png";